// extracted by mini-css-extract-plugin
export default {"mydiv":"skills_mydiv__h7DJP"};